import { TechnicalError } from '../../../common/errors';
import Result from '../../../common/result';
import {
  IdentityTokenStepValue,
  ProcessStepRequest,
  Step,
  StepResult,
  Validation,
  ValidationStatus,
  ValidationStep,
  ValidationStepStatus,
} from '../validationService';
import { Action, UserFlow } from '../../../config/networkConfig';
import LocalOrRemoteValidationService from './localOrRemoteValidationService';

export default class FaceScanValidationService extends LocalOrRemoteValidationService {
  private step: Step;

  constructor(flow: UserFlow, validationStep: ValidationStep, action: Action) {
    super(flow, action);
    this.step = {
      name: validationStep,
      status: ValidationStepStatus.awaitingUserInput,
      value: {},
      parameters: {},
    };
  }

  protected getLocalValidation(): Validation {
    return {
      id: this.id,
      status: this.status,
      steps: [this.step],
    };
  }

  private processFaceScanStep(stepValue: IdentityTokenStepValue): StepResult {
    this.step.value = stepValue;
    this.step.status = ValidationStepStatus.accepted;
    this.status = ValidationStatus.completed;
    return Result.successful(this.step);
  }

  protected async processStepLocally(request: ProcessStepRequest): Promise<StepResult> {
    if ([ValidationStep.uniqueness, ValidationStep.faceAuth].includes(request.step)) {
      return this.processFaceScanStep(request.value as IdentityTokenStepValue);
    }
    return Result.failed(new TechnicalError(`Invalid step ${request.step} passed to FaceScanValidationService`));
  }
}
